import styles from './SectionHeader.module.css';

export interface SectionHeaderProps {
  readonly eyebrow: string;
  readonly title: string;
  readonly lede?: string | undefined;
  /** Reduces the bottom margin for sections whose body starts immediately. */
  readonly tight?: boolean | undefined;
  /** Wired to the view's `aria-labelledby`. */
  readonly titleId?: string | undefined;
}

export function SectionHeader({ eyebrow, title, lede, tight, titleId }: SectionHeaderProps) {
  return (
    <header className={`${styles.header} ${tight ? styles.tight : ''}`}>
      <p className={styles.eyebrow}>{eyebrow}</p>
      <h2 className={styles.title} id={titleId}>
        {title}
      </h2>
      {lede ? <p className={styles.lede}>{lede}</p> : null}
    </header>
  );
}
